<template>
  <div class="wrapper">
    <h3>stream</h3>
    <div>
      <el-button @click="setCameraStream">select camera</el-button>
      <el-button @click="setScreenStream">select screen</el-button>
    </div>

    local
    <video autoplay ref="stream" />
    <div>
      <el-button type="success" @click="sendStream">stream</el-button>
    </div>

    <video autoplay ref="remote" />
  </div>
</template>

<script>
import ScreenShare from 'screenshare'

import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'Stream-Controller',
  data () {
    return {
      peer : '',
      room : ''
    }
  },
  computed: {
    ...mapGetters('video', [
      'localStream',
      'remoteStreams'
    ])
  },
  created () {
    this.setLocalStream(this.getFakeStream())

    this.screenShare = ScreenShare.create({ debug: true })

    this.$peer.on('open', id => {
      this.joinRoom(this.$route.params.id)
      console.log(50, `my peer id is ${id}`)
    })
  },
  methods: {
    sendStream () {
      this.room.replaceStream()
    },
    getFakeStream () {
      const canvas = document.createElement('canvas')
      canvas.width = canvas.height = 1
      canvas.getContext('2d')
      return new MediaStream(canvas.captureStream())
    },
    // peer
    joinRoom (roomName) {
      this.$refs.stream.srcObject = this.getFakeStream()
      this.room = this.$peer.joinRoom(roomName, {
        mode           : 'mesh',
        videoCodec     : 'H264',
        stream         : this.getFakeStream(),
        videoBandwidth : 4000
      })
      console.log(`join peer room ${roomName}`)

      this.room.on('peerJoin', joinUserPeerId => {
        console.log(`join user ${joinUserPeerId}`)
      })
      this.room.on('stream', stream => {
        console.log(62, this.$peer.rooms[roomName])
        console.log(70, stream)
        console.log(`streamId is ${stream.peerId}`)
        this.addRemoteStream(stream)
        this.$refs.remote.srcObject = stream
      })
      this.room.on('data', data => {
        console.log(77, data)
      })
      this.room.send('testdata----------')
    },
    setScreenStream () {
      this.screenShare.start({
        width  : 1920,
        height : 1080
      })
        .then(stream => {
          this.setBoardStream(stream)
          this.$refs.stream.srcObject = stream
          if (typeof this.room === 'object') {
            this.room.replaceStream(stream)
          }
        })
        .catch(error => { console.log(error) })
    },
    setCameraStream () {
      navigator.mediaDevices.getUserMedia({
        audio : false,
        video : {
          width  : 1920,
          height : 1080
        }
      })
        .then((stream) => {
          this.$refs.stream.srcObject = stream
          this.setBoardStream(stream)
          if (typeof this.room === 'object') {
            this.room.replaceStream(stream)
          }
        })
    },
    ...mapMutations('video', [
      'setLocalStream',
      'addRemoteStream'
    ]),
    ...mapMutations('video/stream', [
      'setBoardStream'
    ])
  }
}
</script>

<style scoped>
video {
  height   : 150px;
  width    : auto;
  position : relative;
  z-index  : 500;
}
.wrapper {
  background-color: yellow;
  height   : 500px;
  width    : 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/video/controller/stream-controller.vue